// extracted by mini-css-extract-plugin
module.exports = {"spin":"styles-module--spin--2ykBK","rotation":"styles-module--rotation--3yFhR","clickable":"styles-module--clickable--1Pgj6"};